import {
  differenceInCalendarMonths,
  differenceInMonths,
  format,
  subMonths,
} from "date-fns"
import * as _ from "lodash"

const baseOptions = <const>[
  {label: "Last month", months: 1},
  {label: "Last 3 months", months: 3},
  {label: "Last 6 months", months: 6},
  {label: "Last year", months: 12},
  {label: "Last 2 years", months: 24},
]

export class DateRangeSelector {
  selected?: DateRange = <any>null

  preDefinedOptions: Array<{
    label: string
    value: DateRange
  }> = <any>null

  constructor(readonly available: DateRange) {
    const totalMonthsAvailable = differenceInCalendarMonths(
      available.end,
      available.start
    )

    console.log("totalMonthsAvailable", totalMonthsAvailable)
    this.preDefinedOptions = _.takeWhile(
      baseOptions,
      option => option.months <= totalMonthsAvailable
    ).map(option => ({
      label: option.label,
      value: {
        start: subMonths(available.end, option.months),
        end: available.end,
      },
    }))
  }

  get selectedEndFormatted(): string {
    return this.selected == null
      ? ""
      : this.selected.end.getTime() === this.available.end.getTime()
      ? "Current"
      : formatDate(this.selected.end)
  }

  get selectedPeriodFormatted(): string {
    let formatted = ""

    if (this.selected == null) {
      formatted = ""
    } else if (this.selected.end.getTime() === this.available.end.getTime()) {
      // The last option is more specific e.g. 6 months vs "Since last campaign"
      const start = this.selected.start
      const existingOption = _.findLast(
        this.preDefinedOptions,
        option => option.value.start.getTime() === start.getTime()
      )

      if (existingOption == null) {
        const totalMonths = differenceInMonths(
          this.selected.end,
          this.selected.start
        )
        formatted = `Last ${formatPeriod(totalMonths)}`
      } else {
        formatted = existingOption.label
      }
    } else {
      formatted += `${formatDate(this.selected.start)} - ${formatDate(
        this.selected.end
      )}`
    }

    return formatted
  }
}

function formatDate(date?: Date) {
  return date == null ? "" : format(date, "MMM yyyy")
}

function formatPeriod(months: number): string {
  if (months % 12 === 0) {
    if (months === 12) {
      return "year"
    } else {
      return `${months / 12} years`
    }
  } else if (months === 1) {
    return "month"
  } else {
    return `${months} months`
  }
}

export interface DateRange {
  start: Date
  end: Date
}
